import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popover, PopoverBody, UncontrolledTooltip } from 'reactstrap';
import i18n from 'i18next';

import { FolderTypes } from '../../services/folder';
import './folder-item.scss';
import '../../styles/main.scss';
import '../common/tooltip.scss';
import FolderNewIcon from '../../assets/icons/folder-new.svg?react';
import OptionsIcon from '../../assets/icons/options-vertical.svg?react';
import InboxIcon from '../../assets/icons/icon-inbox.svg?react';
import DeleteIcon from '../../assets/icons/delete.svg?react';
import DocTextIcon from '../../assets/icons/doc-text.svg?react';
import SendIcon from '../../assets/icons/send-arrow.svg?react';
import FolderIcon from '../../assets/icons/folder.svg?react';
import RenameIcon from '../../assets/icons/rename.svg?react';

class FolderItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dragOver: false,
      contextMenuVisible: false
    };
    this.handleOnDragStart = this.onDragStart.bind(this);
    this.handleOnDragOver = this.onDragOver.bind(this);
    this.handleOnDragLeave = this.onDragLeave.bind(this);
    this.handleOnDrop = this.onDrop.bind(this);
    this.itemRef = React.createRef(null);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside = event => {
    if (this.itemRef.current && !this.itemRef.current.contains(event.target)) {
      this.setState({ contextMenuVisible: false });
    }
  };

  hasNoInferiorsAttribute() {
    const { folder } = this.props;
    const { attributes } = folder || {};

    // Check if attributes is defined and is an array
    if (!attributes || !Array.isArray(attributes)) {
      return false;
    }

    // Check if any attribute contains "NoInferiors"
    return attributes.some(
      attr => typeof attr === 'string' && attr.includes('NoInferiors')
    );
  }

  getPaddingLeft = level => {
    if (level === 1) {
      return `0px`;
    } else if (level === 2) {
      return '14px';
    } else if (level === 3) {
      return '28px';
    }
    return `0px`;
  };

  getIcon(graphic) {
    switch (graphic) {
      case 'move_to_inbox':
        return <InboxIcon className="item-icon" />;
      case "delete_outline":
        return <DeleteIcon className="item-icon" width={12} height={14} />;
      case "border_color":
        return <DocTextIcon className="item-icon" />;
      case "send":
        return <SendIcon className="item-icon" width={14} height={11} />;
      default:
        return <FolderIcon className="item-icon" fill="var(--grey-800)" />;
    }
  }

  render() {
    const { contextMenuVisible } = this.state;

    const {
      folderId,
      className,
      selected,
      draggable,
      graphic,
      label,
      newMessageCount,
      unreadMessageCount,
      onClick,
      onRename,
      onAddChild,
      onDelete,
      hasChildren,
      checkSelectedChildren,
      toggleChildren,
      collapsed,
      toggle,
      level,
      onMoveFolder,
      isFirst,
      isLast,
      folder
    } = this.props;
    const { dragOver } = this.state;
    const conditionalDraggableAttributes = {};
    if (draggable) {
      conditionalDraggableAttributes.draggable = true;
      // Support for MS Edge DnD requires link to have a href attribute
      conditionalDraggableAttributes.href = '#';
      conditionalDraggableAttributes.onDragStart = this.handleOnDragStart;
    }
    const popoverTargetEl = document.querySelectorAll(
      `#context-menu-${folderId}`
    );
    return (
      <React.Fragment>
        {toggle && (
          <div className="folder-item" ref={this.itemRef}>
            <div
              style={{
                width: '100%',
                paddingLeft: collapsed ? '0px' : this.getPaddingLeft(level)
              }}
            >
              <div
                id={`folder-item-${folderId}`}
                className={`${className} mdc-list-item
                listItem
                ${selected ? 'mdc-list-item--activated' : ''}
                ${dragOver ? 'mdc-list-item--selected' : ''}
                `}
                onClick={event => {
                  this.setState({ contextMenuVisible: false });
                  setTimeout(() => {
                    if (onClick) onClick(event, folder);
                  }, 0);
                  if (collapsed && hasChildren) {
                    checkSelectedChildren();
                  }
                }}
                {...conditionalDraggableAttributes}
                onDrop={this.handleOnDrop}
                onDragOver={this.handleOnDragOver}
                onDragLeave={this.handleOnDragLeave}
              >
                <span
                  className={`material-icons mdc-list-item__graphic graphic`}
                >
                  {this.getIcon(graphic)}
                </span>

                {!collapsed && (
                  <span
                    className={`mdc-list-item__primary-text primaryText
                      ${newMessageCount > 0 ? 'hasNewMessages' : ''}`}
                  >
                    {label}
                  </span>
                )}
                {!collapsed && (
                  <span
                    className={
                      unreadMessageCount > 0
                        ? 'msg-count'
                        : 'msg-count  msg-count-transparent'
                    }
                  >
                    {unreadMessageCount > 99 ? '+99' : unreadMessageCount > 0 && unreadMessageCount}
                  </span>
                )}
                {!collapsed && (
                  <div
                    id={`context-menu-${folderId}`}
                    className="item-options-icon"
                    onClick={e => {
                      e.stopPropagation();
                      this.setState({ contextMenuVisible: true });
                    }}
                  >
                    <OptionsIcon />
                  </div>
                )}
                {hasChildren && !collapsed && (
                  <span
                    className={`${
                      toggleChildren
                        ? 'lf-icon lf-icon-angle-down'
                        : 'lf-icon lf-icon-angle-right'
                    }`}
                    onClick={() => {
                      checkSelectedChildren();
                    }}
                  />
                )}
              </div>
              <UncontrolledTooltip
                target={`folder-item-${folderId}`}
                placement="right"
                popperClassName="lf-tooltip"
              >
                {label}
              </UncontrolledTooltip>
            </div>
            {!collapsed && popoverTargetEl && (
              <Popover
                isOpen={contextMenuVisible}
                target={`context-menu-${folderId}`}
                toggle={() => {
                  this.setState({ contextMenuVisible: false });
                }}
                placement="left-end"
                className="popover-context-menu"
              >
                <PopoverBody>
                  <div className="menu-option-container">
                    {onAddChild !== null && !this.hasNoInferiorsAttribute() && (
                      <div
                        className="d-flex align-items-center menu-option-item"
                        onClick={event => {
                          onAddChild(event);
                          this.setState({ contextMenuVisible: false });
                        }}
                      >
                        <FolderNewIcon className="mr-3" fill="#262626"/>
                        <span className="menu-option-item-text">
                          {i18n.t('createFolderDialog.title')}
                        </span>
                      </div>
                    )}
                    {onRename !== null && (
                      <div
                        className="d-flex align-items-center menu-option-item"
                        onClick={event => {
                          onRename(event);
                          this.setState({ contextMenuVisible: false });
                        }}
                      >
                        <RenameIcon className="mr-3" fill="#262626" />
                        <span className="menu-option-item-text">
                          {i18n.t('renameFolderDialog.title')}
                        </span>
                      </div>
                    )}
                    <div className="separator-menu-option-item" />
                    <div
                      className={`d-flex align-items-center menu-option-item ${
                        isFirst ? 'disabled' : ''
                      }`}
                      onClick={event => {
                        if (!isFirst) {
                          onMoveFolder(event, 'up');
                        }
                      }}
                    >
                      <img
                        src={`/assets/images/arrow-up.svg`}
                        alt=""
                        width="14px"
                        height="14px"
                        className={`mr-3 ${isFirst ? 'disabled' : ''}`}
                      />
                      <span className="menu-option-item-text">
                        {i18n.t('sideBar.list-up')}
                      </span>
                    </div>
                    <div
                      className={`d-flex align-items-center menu-option-item ${
                        isLast ? 'disabled' : ''
                      }`}
                      onClick={event => {
                        if (!isLast) {
                          onMoveFolder(event, 'down');
                        }
                      }}
                    >
                      <img
                        src={`/assets/images/arrow-down.svg`}
                        alt=""
                        width="14px"
                        height="14px"
                        className={`mr-3 ${isLast ? 'disabled' : ''}`}
                      />
                      <span className="menu-option-item-text">
                        {i18n.t('sideBar.list-down')}
                      </span>
                    </div>
                    {onDelete !== null && (
                      <div className="separator-menu-option-item" />
                    )}
                    {onDelete !== null && (
                      <div
                        className="d-flex align-items-center menu-option-item"
                        onClick={event => {
                          onDelete(event);
                          this.setState({ contextMenuVisible: false });
                        }}
                      >
                        <img
                          src={`/assets/images/delete.svg`}
                          alt=""
                          width="14px"
                          height="14px"
                          className="mr-3"
                        />
                        <span className="menu-option-item-text">
                          {i18n.t(
                            `${
                              hasChildren ? 'general.remove' : 'general.remove'
                            }`
                          )}
                        </span>
                      </div>
                    )}
                  </div>
                </PopoverBody>
              </Popover>
            )}
            <style>{`
            .folder-item {
              .mdc-list-item {
                justify-content: ${!collapsed ? 'flex-start;' : 'center;'};
                flex-direction: ${!collapsed ? 'row;' : 'row-reverse;'};
                padding: 0px 8px 0 8px !important;
                ${collapsed ? 'display: flex !important; grid-template-columns: none !important;' : ''}
                .lf-icon {
                  color: var(--grey-800);
                }
                .graphic {
                  margin-right: ${!collapsed ? '5px' : '0'};
                }
              }
              .disabled {
                opacity: 0.5;
                pointer-events: none;
              }
            }

            `}</style>
          </div>
        )}
      </React.Fragment>
    );
  }

  onDragStart(event) {
    event.stopPropagation();
    this.props.onDragStart(event);
  }

  onDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ dragOver: false });
    this.props.onDrop(event);
  }

  onDragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    if (
      event.dataTransfer.types &&
      Array.from(event.dataTransfer.types).includes('application/json')
    ) {
      this.setState({ dragOver: true });
    }
  }

  onDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ dragOver: false });
  }
}

FolderItem.propTypes = {
  className: PropTypes.string,
  graphic: PropTypes.string,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  draggable: PropTypes.bool,
  onDragStart: PropTypes.func,
  onDrop: PropTypes.func,
  onClick: PropTypes.func,
  onRename: PropTypes.func,
  onAddChild: PropTypes.func,
  onDelete: PropTypes.func,
  unreadMessageCount: PropTypes.number,
  newMessageCount: PropTypes.number,
  folderId: PropTypes.string
};

FolderItem.defaultProps = {
  className: '',
  graphic: FolderTypes.FOLDER.icon,
  selected: false,
  draggable: false,
  unreadMessageCount: 0,
  newMessageCount: 0,
  onDragStart: () => {},
  onDrop: null,
  onRename: null,
  onAddChild: null,
  onDelete: null,
  folderId: ''
};

export default FolderItem;
